import { TCity, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../members/axios';

type TParams = {
  stateId?: number | null;
  // Only used when the country has no states on file — see
  // GeographyController.getCities for the server-side validation.
  countryId?: number | null;
};

export const getCitiesQueryKey = (stateId: number | null | undefined, countryId: number | null | undefined) =>
  ['geography', 'cities', stateId, countryId] as const;

export const useGetCitiesQuery = ({ stateId, countryId }: TParams = {}) =>
  useQuery<TCity[], TError>({
    queryKey: getCitiesQueryKey(stateId, countryId),
    queryFn: async () => {
      const { data } = await axios.get<TCity[]>('geography/cities', {
        params: stateId ? { stateId } : { countryId },
      });
      return data;
    },
    enabled: !!stateId || !!countryId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
